export default "__VITE_ASSET__910fb1c2__"